module.exports = __webpack_public_path__ + "static/media/arrow-up.1b13e2ce.svg";